import { ShoppingCart } from 'lucide-react';
import { useUi } from '../stores/ui.js';
import { Button } from '../ui/Button.js';

/**
 * Secondaire par défaut : sur les vues tâches il accompagne « nouvelle tâche », qui est la
 * primaire. Sur Courses il EST la primaire (une par vue, ADR 0007) — `primary`.
 */
export function AddCourseButton({
  primary = false,
  className,
}: {
  primary?: boolean;
  className?: string;
}): React.ReactElement {
  const open = useUi((s) => s.openCourseAdd);
  return (
    <Button
      variant={primary ? 'primary' : 'secondary'}
      size="icon"
      onClick={() => open()}
      aria-label="Add course"
      className={className}
    >
      <ShoppingCart size={18} aria-hidden />
    </Button>
  );
}
